import { Component, OnInit } from '@angular/core'
import { DataService } from 'app/services/data.service'
import { PAGETRANSITIONS, PageTransitionService } from 'app/services/page-transition.service'
import { Router } from '@angular/router'
import { trigger, transition, style, animate } from '@angular/animations'
import * as _ from 'lodash'
import moment from 'moment'
import { Phase, PlanDocumentUtils } from '../../shared/document-sync'
import { DocumentService } from 'app/services/document.service'
import { InitMain } from 'app/state';
import { Store } from '@ngxs/store';

@Component({
  standalone: false,
  selector: 'app-workout-history',
  templateUrl: './workout-history.component.html',
  styleUrls: ['./workout-history.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('300ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})
export class WorkoutHistoryComponent implements OnInit {
  sessions: any
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private store: Store,
    private dataService: DataService,
    private documentService: DocumentService,
    private pageTransitionService: PageTransitionService,
  ) { }

  ngOnInit() {
    this.loadSessions()
  }

  async loadSessions() {
    const documents = await this.dataService.getAllWorkoutSessionDocuments()
    const filteredSessions = _.filter(documents, (doc: any) => {
      const currentDate = moment().startOf('day').hour(12)
      if (doc.document.end_time) {
        const end_time = moment(doc.document.end_time)
        if (currentDate.diff(end_time, 'months') <= 3) {
          return true
        }
      }
    })
    await this.documentService.restoreData().toPromise()
    this.sessions = _.orderBy(filteredSessions, s => s.document.end_time, 'desc').map(m => {
      const doc = m.document
      doc.total_load = Math.floor(doc.rpe * (doc.completion_time_ms / 1000 / 60)) || 0
      doc.end_time_pretty = moment(doc.end_time).format('MMMM DD, YYYY')

      if (!doc.plan.id || !doc.workout || !doc.workout.id) {
          return doc;
      }

      // Used for historic sessions too
      if (!doc.phase) {
        const planDocument = this.documentService.store.planDocuments.find((planDoc) => {
          return planDoc.document.id === doc.plan.id
        })
        // Unusual issue where a planDocument won't exist for a key/id
        if (planDocument) {
          const workout = planDocument.document.workouts.find((workoutDoc) => {
            return workoutDoc.id === doc.workout.id
          })
          if (!workout) {
            return doc;
          }
          const phase: Phase = PlanDocumentUtils.findPhase(planDocument.document.phases, {
            day: workout.schedule.day[0], week: workout.schedule.week[0]
          })
          if (phase) {
            doc.phase = {
              uuid: phase.id,
              name: phase.name,
              color: phase.color
            }
          }
        }
      }
      return doc
    })
  }

  async onClickCard(session) {
    if (session && session.id) {
      this.isLoading = true;
      await this.onRefreshData();
      const documents = await this.dataService.getAllWorkoutSessionDocuments()
      const filteredSessions = _.filter(documents, (doc: any) => {
        if (doc.document.id === session.id) {
            return true
          }
      });
      this.isLoading = !this.isLoading;
      if (filteredSessions.length > 0) {
        this.pageTransitionService.setCurrentAnimation(PAGETRANSITIONS.LEFT)      
        this.router.navigate(['exercise', 'complete', session.id])
      }
    }    
  }

  async onRefreshData() {
    await this.store.dispatch(new InitMain(true));
    await this.documentService.restoreData().toPromise();    
  }
}
